import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CarTransferProfile from '@/components/Acts/CarTransferProfile/CarTransferProfile';
import ReturnCar from '@/components/Acts/ReturnCar/ReturnCar';
import Cabinet from '@/components/Cabinet/Cabinet';
import Chatwoot from '@/components/Chatwoot/Chatwoot';
import Finances from '@/components/Finances/Finances';
import Header from '@/components/Header/Header';
import ForceCompletedTrip from '@/components/OfficeTrip/ForceCompletedTrip/ForceCompletedTrip';
import ForceUnassignedTrip from '@/components/OfficeTrip/ForceUnassignedTrip/ForceUnassignedTrip';
import OfficeTrip from '@/components/OfficeTrip/OfficeTrip';
import CreateOfficeTrips from '@/components/OfficeTrips/CreateOfficeTrips/CreateOfficeTrips';
import OfficeTrips from '@/components/OfficeTrips/OfficeTrips';
import PollingController from '@/components/PollingController/PollingController';
import Settings from '@/components/Settings/Settings';
import Trips from '@/components/Trips/Trips';
import classes from '@/containers/App/Global.module.scss';
import useAppDispatch from '@/hooks/useAppDispatch';
import useAppSelector from '@/hooks/useAppSelector';
import useMeState from '@/hooks/useMeState';
import { routes } from '@/utils/constants';
import { parsePositiveInt } from '@/utils/helpers';
const POOL_INTERVAL = parsePositiveInt(process.env.POOL_INTERVAL, 5000);
const POOL_INTERVAL_INTENSIVE = parsePositiveInt(process.env.POOL_INTERVAL_INTENSIVE, 300);
const ProtectedRoutes = () => {
    var _a, _b;
    const { setOfficeTripPopup } = useAppDispatch();
    const { officeTripsEnabled } = useAppSelector((state) => state.auth.settings);
    const { meState } = useMeState();
    const forceCompletedTripRequestId = (_a = meState === null || meState === void 0 ? void 0 : meState.forceCompletedTripRequestId) !== null && _a !== void 0 ? _a : null;
    const forceUnassignedTripRequest = (_b = meState === null || meState === void 0 ? void 0 : meState.forceUnassignedTripRequest) !== null && _b !== void 0 ? _b : null;
    useEffect(() => {
        if (officeTripsEnabled && forceCompletedTripRequestId) {
            setOfficeTripPopup('forceCompletedTrip', true);
        }
    }, [officeTripsEnabled, forceCompletedTripRequestId, setOfficeTripPopup]);
    useEffect(() => {
        if (officeTripsEnabled && forceUnassignedTripRequest) {
            setOfficeTripPopup('forceUnassignedTrip', true);
        }
    }, [officeTripsEnabled, forceUnassignedTripRequest, setOfficeTripPopup]);
    return (React.createElement("div", { className: classes.wrapper },
        officeTripsEnabled && React.createElement(PollingController, { pollInterval: POOL_INTERVAL, pollIntervalIntensive: POOL_INTERVAL_INTENSIVE }),
        React.createElement(Header, null),
        React.createElement(Routes, null,
            React.createElement(Route, { path: routes.cabinet.f, element: React.createElement(Cabinet, null) }),
            React.createElement(Route, { path: routes.officeTrips.f, element: officeTripsEnabled ? React.createElement(OfficeTrips, null) : React.createElement(Navigate, { to: routes.cabinet.f }) }),
            React.createElement(Route, { path: routes.createOfficeTrips.f, element: officeTripsEnabled ? React.createElement(CreateOfficeTrips, null) : React.createElement(Navigate, { to: routes.cabinet.f }) }),
            React.createElement(Route, { path: `${routes.carTransfer.f}/:id`, element: React.createElement(CarTransferProfile, null) }),
            React.createElement(Route, { path: routes.returnCar.f, element: React.createElement(ReturnCar, null) }),
            React.createElement(Route, { path: routes.finances.f, element: React.createElement(Finances, null) }),
            React.createElement(Route, { path: routes.trips.f, element: officeTripsEnabled ? React.createElement(Trips, null) : React.createElement(Navigate, { to: routes.cabinet.f }) }),
            React.createElement(Route, { path: routes.chatwoot.f, element: React.createElement(Chatwoot, null) }),
            React.createElement(Route, { path: routes.settings.f, element: React.createElement(Settings, null) }),
            React.createElement(Route, { path: "/", element: React.createElement(Navigate, { to: routes.cabinet.f }) }),
            React.createElement(Route, { path: "*", element: React.createElement(Navigate, { to: routes.cabinet.f }) })),
        officeTripsEnabled && (React.createElement(React.Fragment, null,
            React.createElement(OfficeTrip, null),
            React.createElement(ForceCompletedTrip, null),
            React.createElement(ForceUnassignedTrip, null)))));
};
export default ProtectedRoutes;
